import { createAction, props } from '@ngrx/store';

import { NotaryRequest } from '@core/models/notary-request.model';

// export const SELECTALL = '[NotaryRequest] Select All';
export const SELECT = '[NotaryRequest] Select';
export const UPDATE = '[NotaryRequest] Update';
export const PATCH = '[NotaryRequest] Patch';
export const REMOVE = '[NotaryRequest] Remove';

// export const selectAll = createAction(SELECTALL, props<{ notaryRequests: NotaryRequest[] }>());
export const select = createAction(SELECT, props<{ notaryRequest: NotaryRequest }>());
export const update = createAction(UPDATE, props<{ notaryRequest: NotaryRequest }>());
export const patch = createAction(PATCH, props<{ notaryRequestPartial: Partial<NotaryRequest> }>());
export const remove = createAction(REMOVE);
